import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { setActiveProjectIC } from "../../store/comprehensiveImageViewer/imageViewerlikeContext";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function QuesAns({ data }) {
  const dispatch = useDispatch();
  if (data.projectName === "opti_live1") {
    dispatch(setActiveProjectIC("thailand-live"));
  } else {
    dispatch(setActiveProjectIC("india-live"));
  }
  const { activeProjectIC } = useSelector((state) => state.imageVCStore);
  // console.log(data, "data");
  const customerAnswers = data.customerAnswer;
  const validateAnswer = data.validateAnswer
    ? data.validateAnswer
    : data.customerAnswer;
  const [selectedFilter, setSelectedFilter] = useState(["All"]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [mappingData, setMappingData] = useState([]);
  const [editedAnswers, setEditedAnswers] = useState({});
  const [updatedFilteredAnswers, setUpdatedFilteredAnswers] = useState([]);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let apiUrl = "";

        if (data.projectName === "ira-india") {
          apiUrl = "/get_context/get_ircp_mapping";
        } else if (data.projectName === "opti_live1") {
          apiUrl = "/get_context/get_mapping";
        }

        if (apiUrl) {
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          });

          if (response.ok) {
            const jsonData = await response.json();
            setMappingData(jsonData);
          } else {
            console.error("Error fetching mapping data:", response.statusText);
          }
        } else {
          console.error("Invalid projectName:", data.projectName);
        }
      } catch (error) {
        console.error("Error fetching mapping data:", error);
      }
    };

    fetchData();
  }, [data.projectName]);

  const handleAnswerChange = (questionId, question, newValue) => {
    const isNumber = !isNaN(newValue);

    setEditedAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: {
        answer: isNumber ? Number(newValue) : newValue,
        question: question,
      },
    }));
  };

  const handleSave = async () => {
    if (Object.keys(editedAnswers).length === 0) {
      try {
        const response = await fetch("/get_context/save_answers", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            key: [
              {
                auditID: data.AuditID,
                activeProjectIC: activeProjectIC,
              },
            ],
          }),
        });

        if (response.ok) {
          console.log(
            "Data not edited, only activeProjectIC and auditID sent."
          );
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
        } else {
          console.error("Error saving answers:", response.statusText);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Error saving answers:", error);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } else {
      const updatedAnswersWithAuditID = filteredCustomerAnswers
        .filter((item) => editedAnswers[item.questionId] !== undefined)
        .map((item) => {
          const updatedAnswer = editedAnswers[item.questionId];
          return {
            ...item,
            answer: updatedAnswer.answer,
            auditID: data.AuditID,
            activeProjectIC: activeProjectIC,
          };
        });

      try {
        const response = await fetch("/get_context/save_answers", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ key: updatedAnswersWithAuditID }),
        });

        if (response.ok) {
          console.log("Answers saved successfully");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
        } else {
          console.error("Error saving answers:", response.statusText);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Error saving answers:", error);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    }
  };

  const filterOptions = ["DGP", "VGP", "SOS", "SOD"];

  const filteredCustomerAnswers = Object.entries(customerAnswers)
    .map(([questionId, [answer, question]]) => {
      const mappedQuestion = mappingData.find((map) => map[3] === questionId);
      const questionType = mappedQuestion ? mappedQuestion[1] : "-";
      return {
        questionId,
        answer,
        question,
        questionType,
      };
    })
    .filter(
      (item) =>
        selectedFilter.includes("All") ||
        selectedFilter.includes(item.questionType)
    );

  const validateAnswerFilter = Object.entries(validateAnswer)
    .map(([questionId, [answer, question]]) => {
      const mappedQuestion = mappingData.find((map) => map[3] === questionId);
      const questionType = mappedQuestion ? mappedQuestion[1] : "-";
      return {
        questionId,
        answer,
        question,
        questionType,
      };
    })
    .filter(
      (item) =>
        selectedFilter.includes("All") ||
        selectedFilter.includes(item.questionType)
    );

  // console.log(filteredCustomerAnswers, "cns");

  return (
    <div>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflow: "auto",
          height: "530px",
          // margin: "auto",
        }}
      >
        <Table
          // sx={{ width: "60vw", margin: "auto", overflow: "auto" }}
          sx={{ width: "100%" }}
          aria-label="customized table"
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>
                <Box display="flex" alignItems="center">
                  <span style={{ marginRight: "8px" }}>Question Id</span>
                </Box>
              </StyledTableCell>
              <StyledTableCell>Question</StyledTableCell>
              <StyledTableCell>
                <Select
                  value={selectedFilter}
                  onChange={(event) => setSelectedFilter(event.target.value)}
                  variant="outlined"
                  style={{
                    borderRadius: "8px",
                    backgroundColor: "white",
                    width: "120px",
                    height: "40px",
                  }}
                  multiple
                >
                  <MenuItem key="All" value="All">
                    All
                  </MenuItem>
                  {filterOptions.map((filter) => (
                    <MenuItem key={filter} value={filter}>
                      {filter}
                    </MenuItem>
                  ))}
                </Select>
              </StyledTableCell>
              <StyledTableCell>Answer</StyledTableCell>
              {/* <StyledTableCell>Hi Answer</StyledTableCell> */}
            </TableRow>
          </TableHead>
          {/* <TableBody>
            {filteredCustomerAnswers.map((item) => (
              <StyledTableRow key={item.questionId}>
                <StyledTableCell>{item.questionId}</StyledTableCell>
                <StyledTableCell>{item.question}</StyledTableCell>
                <StyledTableCell>{item.questionType}</StyledTableCell>
                <StyledTableCell>{item.answer}</StyledTableCell>
                <StyledTableCell>
                  <div
                    contentEditable
                    onBlur={(e) =>
                      handleAnswerChange(
                        item.questionId,
                        item.question,
                        e.target.innerText
                      )
                    }
                    dangerouslySetInnerHTML={{
                      __html:
                        editedAnswers[item.questionId] !== undefined
                          ? editedAnswers[item.questionId].answer
                          : item.answer,
                    }}
                    style={{ borderBottom: "1px solid #000" }}
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody> */}

          {/* <TableBody>
            {filteredCustomerAnswers.map((customerItem) => {
              const validateItem = validateAnswerFilter.find(
                (item) => item.questionId === customerItem.questionId
              );

              return (
                <StyledTableRow key={customerItem.questionId}>
                  <StyledTableCell>{customerItem.questionId}</StyledTableCell>
                  <StyledTableCell>{customerItem.question}</StyledTableCell>
                  <StyledTableCell>{customerItem.questionType}</StyledTableCell>
                  <StyledTableCell>{customerItem.answer}</StyledTableCell>
                  {validateItem && (
                    <StyledTableCell>
                      <div
                        contentEditable
                        onBlur={(e) =>
                          handleAnswerChange(
                            validateItem.questionId,
                            validateItem.question,
                            e.target.innerText
                          )
                        }
                        dangerouslySetInnerHTML={{
                          __html:
                            editedAnswers[validateItem.questionId] !== undefined
                              ? editedAnswers[validateItem.questionId].answer
                              : validateItem.answer,
                        }}
                        style={{ borderBottom: "1px solid #000" }}
                      />
                    </StyledTableCell>
                  )}
                </StyledTableRow>
              );
            })}
          </TableBody> */}

          <TableBody>
            {filteredCustomerAnswers.map((customerItem) => {
              const validateItem = validateAnswerFilter.find(
                (item) => item.questionId === customerItem.questionId
              );
              const highlightRow =
                validateItem && customerItem.answer !== validateItem.answer;

              return (
                <StyledTableRow
                  key={customerItem.questionId}
                  sx={{ backgroundColor: highlightRow ? "#ffcccc" : "inherit" }}
                >
                  <StyledTableCell>{customerItem.questionId}</StyledTableCell>
                  <StyledTableCell>{customerItem.question}</StyledTableCell>
                  <StyledTableCell>{customerItem.questionType}</StyledTableCell>
                  <StyledTableCell>{customerItem.answer}</StyledTableCell>
                  {/* {validateItem && (
                    <StyledTableCell>
                      <div
                        contentEditable
                        onBlur={(e) =>
                          handleAnswerChange(
                            validateItem.questionId,
                            validateItem.question,
                            e.target.innerText
                          )
                        }
                        dangerouslySetInnerHTML={{
                          __html:
                            editedAnswers[validateItem.questionId] !== undefined
                              ? editedAnswers[validateItem.questionId].answer
                              : validateItem.answer,
                        }}
                        style={{ borderBottom: "1px solid #000" }}
                      />
                    </StyledTableCell>
                  )} */}
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* <Box
        mt={3}
        // sx={{ display: "flex", width: "43%", justifyContent: "center" }}
        sx={{ display: "flex", justifyContent: "flex-start" }}
      >
        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </Box> */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={snackbarSeverity}
          onClose={handleCloseSnackbar}
        >
          {snackbarSeverity === "success"
            ? "Saving is successful"
            : "Saving failed"}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}
